<div class="faq-page">
    <lokos-page-header [label]="'FAQs'" [breadcrumbs]="breadcrumbs()" />

    <div class="faq-content">
        <h3 class="faq-section-title">SECTION 1 : BPMs</h3>

        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="question-text">
                            1. SHG is not visible in the BPM login (My Task)?
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="answer-text">
                    <p class="case">Case 1: If SHG is incomplete</p>
                    <p>Step 1: In BPM login, click on the "Menu bar" &#8594; SHG</p>
                    <p>Step 2: Click on SHG profile</p>
                    <p>
                        Step 3: Fill the information in SHG profile search page such
                        as Gram Panchayat and village where your SHG exists. You can
                        search from Group Name or Group Code as well.
                    </p>
                    <p>Step 4: Click on the search button, the SHG name will be visible</p>
                    <p>Step 5: Click on View Status (check status from dropdown)</p>
                    <p>
                        Step 5.1: If View Status shows "Incomplete SHG" then it will
                        not reflect in My Task (bank account may not be available for
                        this SHG)
                    </p>
                    <p class="case">
                        Case 2: Complete SHG profile (with minimum 5 members and bank
                        account) not visible in My Task
                    </p>
                    <p class="emphasis">
                        Block Team to contact SHG e-bookkeeper for the following
                        steps:
                    </p>
                    <p>Step 1: Click on SHG Profile synchronisation</p>
                    <p>
                        Step 2: Click on "upload status" &#8594; pop up message will
                        appear saying:
                    </p>
                    <p>i. "data downloaded successfully"; in case SHG uploaded</p>
                    <p>ii. "Nothing to download"; in case SHG is not uploaded</p>
                    <p>Step 3: Click on SHG</p>
                    <p>
                        Step 3.1: SHG lock is open (query solved and further steps to
                        be taken)
                    </p>
                    <p>Step 3.2: SHG is locked, then follow steps below</p>
                    <p>Step 4: Click on the 3 dots</p>
                    <p>Step 5: Click on "View Upload Status"</p>
                    <p>
                        a. If it shows "data updated/inserted successfully", then data
                        will be available on BPM portal after midnight (12AM on daily
                        basis) (either My Task in case SHG profile is complete or View
                        status in case SHG profile is incomplete)
                    </p>
                    <p>
                        b. If it shows "record processing in state", it means the data
                        is in the process of uploading. When the process is completed,
                        it will be visible on the BPM portal. After successful upload,
                        status will change to "data updated/inserted successfully".
                    </p>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="question-text">
                            2. Where to see SHGs and SHG members at BPM level (BPM
                            portal login)?
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="answer-text">
                    <p>Step 1: In BPM login, click on the "Menu bar" &#8594; SHG</p>
                    <p>Step 2: Click on SHG profile</p>
                    <p>
                        Step 3: Fill the information in SHG profile search page such
                        as Gram Panchayat and village where your SHG exists. You can
                        search from Group Name or Group Code as well.
                    </p>
                    <p>Step 4: Click on the search button, the SHG name will be visible</p>
                    <p>
                        Step 5: Select the "View" option &#8594; SHG details will be
                        visible, and the member list option will be highlighted in
                        blue colour (hyperlink)
                    </p>
                    <p>Step 6: Click on "Member List" and the member list will be visible.</p>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="question-text">
                            3. In BPM Login &#8594; My Task &#8594; "SHG Profile
                            Verification and Activation" shows "Confirm Duplicate" or
                            "Potential Duplicate" for a member and "Confirm Duplicate"
                            for SHG. What to do?
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="answer-text">
                    <p>Step 1: Login to BPM Portal</p>
                    <p>Step 2: Click on Menu bar on the left side &#8594; Click on My Task</p>
                    <p>Step 3: Click on "SHG Profile Verification and Activation"</p>
                    <p>Step 4: You will see "SHG Profile" and "Member"</p>
                    <p>Step 5: Click on Member Details</p>
                    <p class="case">Case 1: If the confirmation shows 'Potential Duplicate':</p>
                    <p>
                        Step 1: It means the same mobile number already exists with
                        some other members of the SHG &#8594; this can be approved.
                        There is no restriction on the same mobile number used
                        multiple times.
                    </p>
                    <p class="case">Case 2: If the confirmation shows 'Confirm Duplicate':</p>
                    <p>This can appear either with "Bank Account" or "Aadhaar" or both</p>
                    <p>Step 1: Click on the "i" button next to confirm duplicate</p>
                    <p>Step 2: A pop up message with confirmed duplicate details will appear</p>
                    <p>
                        Step 3: This profile has to be rejected by clicking on Action
                        &#8594; Tick on Reject box
                    </p>
                    <p>
                        Step 4: Click on "Rejection remark" &#8594; Select the reason
                        from dropdown
                    </p>
                    <p>
                        Step 5: Click on "Reject Profile Changes" with remarks. You can
                        paste rejection details at "i" button popup for Aadhaar and
                        Bank Account Details.
                    </p>
                    <p>
                        Step 5.1: In case, confirm duplicate is within the e-bookkeeper
                        geography (area), bookkeeper needs to modify the details on
                        Aadhaar and Bank Account.
                    </p>
                    <p>
                        Step 5.2: In case, confirm duplicate is outside the bookkeeper
                        geography area or block or district or state, matter has to be
                        escalated by BPM with concerned (state/national officials).
                    </p>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="question-text">
                            4. In the BPM Login; Profile "Approve/Reject" button is not
                            visible. What to do?
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="answer-text">
                    <p class="case">Case 1: Profile has come for the first time for BPM Approval</p>
                    <p>Step 1: Login to BPM Portal</p>
                    <p>Step 2: Click on Menu bar on the left side &#8594; Click on My Task</p>
                    <p>Step 3: Click on "SHG Profile Verification and Activation"</p>
                    <p>Step 4: You will see "SHG Profile"</p>
                    <p class="emphasis">
                        Situation 1: If the profile is complete (with minimum 5 members
                        and SHG bank account)
                    </p>
                    <p>
                        Step 1: In case BPM approval is not showing, this may be a
                        technical issue and a ticket needs to be raised.
                    </p>
                    <p class="emphasis">
                        Situation 2: Incomplete profile (SHG with less than 5 members
                        and without bank account)
                    </p>
                    <p>
                        Step 1: Incomplete profile will not show in My Task for BPM
                        Approval. Details can be seen in the SHG Profile search button.
                        (Follow steps 1-5 in Question 2).
                    </p>
                    <p class="case">Case 2: Profile has come for the second time for BPM Approval</p>
                    <p>
                        Reason 1: If the e-bookkeeper has changed none mandatory fields
                        (not with star*), then the action button will not be visible in
                        the SHG profile. If e-bookkeeper has changed mandatory fields
                        (with star *) it will come for BPM approval or rejection.
                    </p>
                    <p>
                        Reason 2: Sometimes due to network issue, SHGs appear without an
                        action button. In this case, coordinate with the bookkeeper to
                        check the upload status and necessary steps as mentioned in
                        Question 1.
                    </p>
                </div>
            </mat-expansion-panel>
        </mat-accordion>

        <h3 class="faq-section-title">SECTION 2 : For E-bookkeepers</h3>

        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="question-text">
                            5. The SHG got locked at Book-keeper level but how will it
                            get unlocked?
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="answer-text">
                    <p>If data is approved/rejected by the BPM then</p>
                    <p>Step 1: Go to SHG profile synchronisation</p>
                    <p>
                        Step 2: Click on "upload status" &#8594; pop up message will
                        appear saying:
                    </p>
                    <p>i. "data downloaded successfully"; in case SHG uploaded</p>
                    <p>ii. "Nothing to download"; in case SHG is not uploaded</p>
                    <p>Step 3: Click on SHG</p>
                    <p>Step 4: Click on the 3 dots</p>
                    <p>Step 5: Click on "approval status"</p>
                    <p>Step 6: After you download approval status, the lock will be unlocked.</p>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="question-text">
                            6. I am not able to login in the mobile application: What
                            can be the reason?
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="answer-text">
                    <p class="emphasis">Reason 1 - ID &amp; Password incorrect</p>
                    <p>Step 1: Contact Block Admin to resolve</p>
                    <p class="emphasis">
                        Reason 2 - Have not updated the latest version of the
                        application
                    </p>
                    <p>Step 1: Go to Playstore and update the latest version of application</p>
                    <p class="emphasis">
                        Reason 3 - E-bookkeeper might have selected another state
                        instead of her own state
                    </p>
                    <p>Step 1: Please select the correct state name</p>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="question-text">
                            7. How to update the LokOS App if "Update" option is not
                            coming?
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="answer-text">
                    <p>Step 1: Go to Play store.</p>
                    <p>Step 2: Type LokOS in search bar</p>
                    <p>Step 3: Click on logo of the LokOS application.</p>
                    <p>Step 4: Update button will be highlighted in blue colour</p>
                    <p>Step 5: Click on the button to update</p>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="question-text">
                            8. What are reasons for Aadhaar verification failure?
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="answer-text">
                    <p class="emphasis">Reason 1 - Aadhaar is not up to date.</p>
                    <p class="emphasis">Reason 2 - Mobile software is not up to date.</p>
                    <p class="emphasis">Reason 3 - Typo errors</p>
                    <p class="emphasis">Reason 4 - Not following proper process.</p>
                    <p class="emphasis">Process of Aadhaar authentication in LokOS:</p>
                    <p>Step 1: Type name and date of birth (as per Aadhaar card)</p>
                    <p>Step 2: Type the Aadhaar number.</p>
                    <p>Step 3: Click on Verify Aadhaar Details</p>
                    <p>
                        Step 4: After clicking on Verify Aadhaar details, a pop-up will
                        appear "Please check date of birth"
                    </p>
                    <p>Step 5: Select the date of birth again</p>
                    <p>Step 6: Click on Verify Aadhaar details</p>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="question-text">
                            9. Can I delete the SHG if it is inactive?
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="answer-text">
                    <p>Case 1: Yes, in case of New SHG</p>
                    <p>
                        Case 2: No, in case of Migrated SHG or approved by BPM in case
                        of new SHG
                    </p>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>
